import { useEffect } from "react";

/* 每日待办跨组件同步：顶栏「每日待办」· /todos「我的待办」· 首页「今日必做」· 聊天 转待办 / 自动入待办 都读同一 todos 集合；
   任一处写入后广播 todos-changed，其余处立即重新拉取（不再等 60 秒轮询） */
export const TODOS_CHANGED = "todos-changed";

export const emitTodosChanged = (from) => window.dispatchEvent(new CustomEvent(TODOS_CHANGED, { detail: { from } }));

export function useTodosChanged(handler, ignoreFrom) {
  useEffect(() => {
    const h = (e) => { if (ignoreFrom && e.detail?.from === ignoreFrom) return; handler(); };
    window.addEventListener(TODOS_CHANGED, h);
    return () => window.removeEventListener(TODOS_CHANGED, h);
  }, [handler, ignoreFrom]);
}
